var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8242 28.75L25.9424 28.7578C26.5381 28.8383 27.1986 29.5068 27.2021 30.6123V33.1172L28.4102 32.1885L30.9268 30.252C31.0274 30.1746 31.1007 30.1423 31.1426 30.1279C31.1515 30.1436 31.1652 30.164 31.1768 30.1943C31.2148 30.2946 31.2496 30.4588 31.25 30.6982V37.2988C31.25 37.5365 31.2156 37.6997 31.1777 37.7998C31.1661 37.8304 31.1526 37.8514 31.1436 37.8672C31.1166 37.858 31.0764 37.8426 31.0244 37.8105L30.9287 37.7451L28.4092 35.8086L27.2021 34.8818V37.3877C27.1982 38.5674 26.4469 39.2484 25.8242 39.25H18.1279C17.543 39.2477 16.846 38.6481 16.7588 37.6006L16.75 37.3857V30.6143C16.7529 29.5079 17.4131 28.8399 18.0098 28.7588L18.1279 28.75H25.8242Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.502b5dedf6d311424738d2c37dd96cfa.svg";
export { ForwardRef as ReactComponent };